module.exports = __webpack_public_path__ + "6cb4482c5425f5102e335d8bb2832f98.svg";